const ServicesMobile = ({ serviceLines }) => {
	return (
		<div>
			<span className='d-block fs-small fw-600 mb-2'>Services</span>
			{/* PDR service */}
			{Object.keys(serviceLines).map(key => {
				return (
				<div className='border rounded p-2 d-flex  fs-sub mt-2' key={key}>
					<div className='pe-3'>
						<div className='fw-600'>{serviceLines[key]}</div>
					</div>
					{/* <div className='flex-grow-1 ms-2 text-end'>
						{serviceLines[key]}
					</div> */}
				</div>
				)
			})}
		</div>
	)
}

export default ServicesMobile
